import React, { useState } from "react";
import { MainMenu } from "@excalidraw/excalidraw/index";
import { save } from "@excalidraw/excalidraw/components/icons";

import { useAtom } from "../app-jotai";
import { collabAPIAtom } from "../collab/Collab";

export const SaveButton = () => {
  const [collabAPI] = useAtom(collabAPIAtom);
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    if (!collabAPI || !collabAPI.isCollaborating()) {
      alert("Save is only available in collaboration mode");
      return;
    }

    try {
      setIsSaving(true);
      // Dispatch custom event for Collab.tsx to handle
      window.dispatchEvent(new CustomEvent("EXCALIDRAW_MANUAL_SAVE"));
    } catch {
    } finally {
      setIsSaving(false);
    }
  };

  if (!collabAPI || !collabAPI.isCollaborating()) {
    return null;
  }

  return (
    <MainMenu.Item
      icon={save}
      onClick={handleSave}
      className={isSaving ? "is-saving" : ""}
    >
      {isSaving ? "Saving..." : "Save to Cloud"}
    </MainMenu.Item>
  );
};
